import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, retry, shareReplay, switchMap } from 'rxjs/operators';
import { defaultEnvironmentConfig, EnvironmentConfig } from '../entities/environment-config.entity';
import { TenantInfo } from '../entities/tenant-info.entity';

@Injectable({
    providedIn: 'root'
})
export class TenantInfoDataService {
    private readonly CONFIG_PATH: string = 'assets/environment.json';
    protected readonly TENANT_ENDPOINT: string = 'tenant-info';
    protected readonly HOST_PLACEHOLDER: string = '%PUBLIC_HOST%';

    protected tenantInfo$: Observable<TenantInfo>;

    private readonly http: HttpClient;

    constructor(httpBackend: HttpBackend) {
        this.http = new HttpClient(httpBackend);
    }

    public getTenantInfo(): Observable<TenantInfo> {
        return this.tenantInfo$ ? this.tenantInfo$ : this.initTenantInfo();
    }

    private initTenantInfo(): Observable<TenantInfo> {
        return (this.tenantInfo$ = this.getConfig().pipe(
            switchMap(config => {
                const tenantUrl: string = config.tenantUrl ?? `https://${window.location.host}`;
                return this.http.get<TenantInfo>(`${tenantUrl}/${this.TENANT_ENDPOINT}`).pipe(retry(2), shareReplay(1));
            }),
            shareReplay(1)
        ));
    }

    private getConfig() {
        return this.http.get<EnvironmentConfig>(this.CONFIG_PATH).pipe(
            retry(2),
            map(config => ({
                ...defaultEnvironmentConfig,
                ...config
            })),
            shareReplay(1)
        );
    }

    public getPortalApiKey(): Observable<string | undefined> {
        return this.getTenantInfo().pipe(
            map(
                tenantInfo =>
                    tenantInfo.ApiKeys.find(apiKey => apiKey.Name === `${tenantInfo.OrganisationName}_portal`)?.Value
            )
        );
    }
}
